import React from "react";
import "./JobHero.scss";

const HeroSection = ({ totalJobs = 0, uniqueLocationCount = 0 }) => {
  return (
    <section className="jobs-hero">
      <div className="hero-img" /> <div className="hero-overlay" />
      <div className="hero-content">
        <p className="hero-kicker">Join S.T.A.R. Services Group</p>
        <h1>Build Your Career With Us</h1>
        <p className="hero-subtitle">
          Discover opportunities across port operations, engineering,
          administration, and logistics support teams.
        </p>
        <div className="hero-highlights">
          <div className="highlight-pill">
            <strong> {totalJobs}</strong> <span>Open Positions</span>
          </div>
          <div className="highlight-pill">
            <strong> {uniqueLocationCount}</strong> <span>Locations</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
